export enum substanceCodetableIds {
  uomSets = 398,
  hierarchy = 341,
  category = 351
}

export const unitOfMeasureTypeId = 334;

export const unitOfMeasureExcludeId = 3699;

export const userGroupCodetableId = 19;

export const defaultUomConversionFactor = 1;
